import { setRisqueDetailsData, resetRisqueDetailsData } from '../../../redux/risqueDetailsDataSlice';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import RisqueDetailsContent from './risqueDetailsContent';
import { useCallback, useEffect, useState } from 'react';
import RisqueDetailsHeader from './risqueDetailsHeader';
import { Box, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const RisqueDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const fetchRisqueDetails = useCallback(async () => {
        try {
            const { data, status } = await axios.get(`risk/${id}`);
            if ((status === 200 || status === 201) && data) {
                dispatch(setRisqueDetailsData(data));
                setLoading(false);
            } else {
                setLoading(false);
                console.warn('Unexpected response status or empty data:', status, data);
            }
        } catch (error) {
            setLoading(false);
            console.error('Erreur lors de la récupération des informations de risque :', error);
            CustomErrorLogger(error, 'Erreur dans fetchRisqueDetails');
        }
    }, [id, dispatch]);

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch risque details on mount and cleanup on unmount
    useEffect(() => {
        fetchRisqueDetails();
        return () => {
            dispatch(resetRisqueDetailsData());
        };
    }, [fetchRisqueDetails, dispatch]);

    return (
        <Box>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                    }}
                >
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <RisqueDetailsHeader />
                    <RisqueDetailsContent />
                    <SuccessfullModifyDialog />
                </Box>
            }
        </Box>
    );
}

export default RisqueDetails;